export function YouTubeVideo({
    youtubeId,
    title = '',
}: {
    youtubeId: string;
    title?: string;
    style?: React.CSSProperties;
}) {
    if (title === '') {
        title = 'Youtube Video';
    }

    return (
        <div className="video">
            <iframe
                className="video-player"
                key={`youtube-${youtubeId}`}
                title={title}
                src={`https://www.youtube.com/embed/${youtubeId}`}
                frameBorder="0"
            />
        </div>
    );
}
